var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_853_769)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_853_769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_853_769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 10.8866C6.40661 10.8866 5.11328 9.59327 5.11328 7.99993C5.11328 6.40661 6.40661 5.11328 7.99993 5.11328C9.59327 5.11328 10.8866 6.40661 10.8866 7.99993C10.8866 9.59327 9.59327 10.8866 7.99993 10.8866ZM7.99993 6.11328C6.95993 6.11328 6.11328 6.95993 6.11328 7.99993C6.11328 9.03993 6.95993 9.8866 7.99993 9.8866C9.03993 9.8866 9.8866 9.03993 9.8866 7.99993C9.8866 6.95993 9.03993 6.11328 7.99993 6.11328Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 14.0137C5.49337 14.0137 3.1267 12.547 1.50003 10.0003C0.793365 8.90034 0.793365 7.107 1.50003 6.00032C3.13337 3.45365 5.50003 1.98698 8.00005 1.98698C10.5 1.98698 12.8667 3.45365 14.4934 6.00032C15.2 7.10034 15.2 8.89367 14.4934 10.0003C12.8667 12.547 10.5 14.0137 8.00005 14.0137ZM8.00005 2.98698C5.8467 2.98698 3.7867 4.28032 2.3467 6.54032C1.8467 7.32034 1.8467 8.68034 2.3467 9.46034C3.7867 11.7203 5.8467 13.0137 8.00005 13.0137C10.1534 13.0137 12.2134 11.7203 13.6534 9.46034C14.1534 8.68034 14.1534 7.32034 13.6534 6.54032C12.2134 4.28032 10.1534 2.98698 8.00005 2.98698Z",
    fill: "#6C6C6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_853_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.ed3635980fcd31a31fbd9ceb1c3b284d.svg";
export { ForwardRef as ReactComponent };